/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createFlyer = /* GraphQL */ `
  mutation CreateFlyer(
    $input: CreateFlyerInput!
    $condition: ModelFlyerConditionInput
  ) {
    createFlyer(input: $input, condition: $condition) {
      id
      title
      contact
      startDate
      endDate
      address
      tel
      website
      permalink
      logoImage
      images
      sponsor
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateFlyer = /* GraphQL */ `
  mutation UpdateFlyer(
    $input: UpdateFlyerInput!
    $condition: ModelFlyerConditionInput
  ) {
    updateFlyer(input: $input, condition: $condition) {
      id
      title
      contact
      startDate
      endDate
      address
      tel
      website
      permalink
      logoImage
      images
      sponsor
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteFlyer = /* GraphQL */ `
  mutation DeleteFlyer(
    $input: DeleteFlyerInput!
    $condition: ModelFlyerConditionInput
  ) {
    deleteFlyer(input: $input, condition: $condition) {
      id
      title
      contact
      startDate
      endDate
      address
      tel
      website
      permalink
      logoImage
      images
      sponsor
      status
      createdAt
      updatedAt
    }
  }
`;
